import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Moon, Eye, Compass, Target, Copy } from 'lucide-react';
import { getWeeklyCycle } from '@/utils/weeklyCycle';
import { copyToClipboard } from '@/utils/copyToClipboard';

// Asmeniniai klausimai kiekvienai kategorijai - DINAMIŠKI pagal savaitės energiją
const getPersonalQuestions = (lifePath, weeklyEnergyType) => {
  // Baziniai klausimai pagal lifePath
  const baseQuestions = {
    busena: {
      1: 'Ar šiandien leidau sau būti pirmu, nesidairydamas aplinkinių pritarimo?',
      2: 'Ko mano širdis šiandien trokšta, kai proto balsas nutyla?',
      3: 'Ar leidau sau šiandien džiaugtis be priežasties?',
      4: 'Ar esu tikrai ten, kur noriu būti - ar tik ten, kur reikia?',
      5: 'Ko iš tikrųjų ieškau visuose šiuose pokyčiuose?',
      6: 'Ar mano meilė kitiems nekyla iš baimės būti vienam?',
      7: 'Kokius atsakymus žinau, bet bijau pripažinti?',
      8: 'Ar mano siekiai yra mano - ar kažkieno lūkesčiai?',
      9: 'Ką privalau paleisti, kad galėčiau eiti toliau?'
    },
    seselis: {
      1: 'O kas manyje labiausiai bijo likti nepastebėtam?',
      2: 'O kas manyje bijo pasakyti „ne" ir likti vienam?',
      3: 'O kas manyje bijo, kad gilus buvimas atskleistų tuštumą?',
      4: 'O kas manyje labiausiai bijo netikėtumų ir kontrolės praradimo?',
      5: 'O kas manyje labiausiai bijo šio sustojimo ir nuobodulio?',
      6: 'O kas manyje bijo, kad be kitų manęs nepakaks?',
      7: 'O kas manyje bijo, kad atsakymai, kuriuos rasiu, man nepatiks?',
      8: 'O kas manyje bijo, kad be pasiekimų esu nevertas meilės?',
      9: 'O kas manyje taip stipriai laikosi praeities?'
    },
    kryptis: {
      1: 'Koks mažas žingsnis šiandien gali parodyti, kad pasitikiu savimi?',
      2: 'Kaip galiu šiandien parodyti meilę, nieko nereikalaudamas atgal?',
      3: 'Kokį džiaugsmą galiu sukurti šiandien - sau ar kitam?',
      4: 'Ką galiu šiandien užbaigti, kad pajausčiau pasitenkinimą?',
      5: 'Kokia nauja perspektyva gali man padėti šiandien?',
      6: 'Kaip galiu šiandien pasirūpinti savimi taip, kaip rūpinuosi kitais?',
      7: 'Kokį vidinį klausimą verta šiandien užduoti sau ramybėje?',
      8: 'Kaip galiu šiandien panaudoti savo galią gerajai pusai?',
      9: 'Ką galiu atleisti šiandien - sau ar kitam?'
    },
    stebejimas: {
      1: 'Kada šiandien pagavau save ieškant patvirtinimo iš išorės?',
      2: 'Kuriuo momentu praradau kontaktą su savo poreikiais?',
      3: 'Ar šiandien buvau tikras - ar vaidinau versiją, kuri patiktų kitiems?',
      4: 'Ar šiandien leisdau sau tiesiog būti, be to, kad viską daryčiau tobulai?',
      5: 'Ar mano nerimas šiandien kilo iš nuobodulio - ar iš tikros problemos?',
      6: 'Ar šiandien pasakiau „taip" kam nors, nors norėjau pasakyti „ne"?',
      7: 'Ar šiandien pasitikėjau savo intuicija - ar tik protu?',
      8: 'Ar šiandien mano sprendimai buvo paremti meile - ar baime?',
      9: 'Ką šiandien atsisakiau paleisti, nors žinojau, kad laikas?'
    }
  };
  
  // Dinamiški klausimai pagal savaitės energijos temą
  const dynamicQuestions = {
    'Lyderystė ir Pradžia': {
      busena: 'Kodėl aš bijau būti pirmu ir pradėti be kitų leidimo?',
      seselis: 'Ar mano skubėjimas veikti nekyla iš baimės būti nepastebėtam?',
      kryptis: 'Koks vienas drąsus žingsnis šiandien parodytų mano tikrąją jėgą?',
      stebejimas: 'Ar mano iniciatyva kyla iš įkvėpimo, ar iš baimės atsilikti?'
    },
    'Partnerystė ir Jautrumas': {
      busena: 'Kodėl man sunku būti pažeidžiamam santykiuose?',
      seselis: 'Ar aš prisitaikau prie kitų prarasdamas savo balsą?',
      kryptis: 'Kaip galiu parodyti meilę, nesitikėdamas nieko atgal?',
      stebejimas: 'Kada šiandien atsisakiau savo poreikių dėl harmonijos?'
    },
    'Kūryba ir Išraiška': {
      busena: 'Ar leidžiu sau kurti be perfekcionizmo spaudimo?',
      seselis: 'Ar mano socialumas nėra bėgimas nuo vidinės tylos?',
      kryptis: 'Kokį kūrybinį impulsą šiandien noriu išreikšti?',
      stebejimas: 'Ar šiandien leidau sau tiesiog žaisti, be tikslo?'
    },
    'Struktūra ir Saugumas': {
      busena: 'Kodėl aš bijau paleisti kontrolę?',
      seselis: 'Ar mano tvarkos poreikis nėra baimė netikėtumų?',
      kryptis: 'Ką galiu užbaigti šiandien, kad pajausčiau ramybę?',
      stebejimas: 'Ar leidau sau šiandien tiesiog būti, be tobulybės poreikio?'
    },
    'Laisvė ir Pokyčiai': {
      busena: 'Kodėl aš bijau sustoti ir būti ramybėje?',
      seselis: 'Ar mano pokyčių ieškojimas nėra bėgimas nuo savęs?',
      kryptis: 'Kokią laisvę galiu rasti tame, ką jau turiu?',
      stebejimas: 'Ar mano nerimas šiandien kilo iš nuobodulio, ar iš tikros problemos?'
    },
    'Harmonija ir Atsakomybė': {
      busena: 'Ar rūpinuosi savimi taip pat, kaip rūpinuosi kitais?',
      seselis: 'Ar mano pagalba kitiems nekyla iš baimės būti nemylimu?',
      kryptis: 'Kaip šiandien galiu būti savo paties geriausiu globėju?',
      stebejimas: 'Ar šiandien pasakiau „taip", nors norėjau pasakyti „ne"?'
    },
    'Išmintis ir Analizė': {
      busena: 'Kokius atsakymus jau žinau, bet bijau pripažinti?',
      seselis: 'Ar mano vienišumas yra pasirinkimas, ar bėgimas nuo ryšio?',
      kryptis: 'Kokį klausimą turėčiau užduoti sau šiandien tyloje?',
      stebejimas: 'Ar šiandien pasitikėjau intuicija, ar tik protu?'
    },
    'Galia ir Balansas': {
      busena: 'Ar naudoju savo galią kurti, ar tik kontroliuoti?',
      seselis: 'Ar mano ambicijos nežeidžia tų, kuriuos myliu?',
      kryptis: 'Kaip šiandien galiu panaudoti savo jėgą kitiems padėti?',
      stebejimas: 'Ar mano sėkmės matas yra tik rezultatai ir skaičiai?'
    },
    'Užbaigimas ir Humanizmas': {
      busena: 'Ko laikausi, nors žinau, kad laikas paleisti?',
      seselis: 'Ar jaučiu pasaulio skausmą kaip savo, pamiršdamas savo gerovę?',
      kryptis: 'Ką galiu atleisti šiandien - sau ar kitam?',
      stebejimas: 'Ar mano ilgesys yra tam, ko tikrai buvo, ar fantazijai?'
    }
  };
  
  const baseNumber = lifePath === 11 ? 2 : lifePath === 22 ? 4 : lifePath === 33 ? 6 : lifePath;
  const num = baseNumber > 9 ? 1 : baseNumber;
  
  // Jei yra dinaminis klausimas pagal savaitės energiją, naudojame jį
  const dynamicQ = dynamicQuestions[weeklyEnergyType];
  
  return {
    busena: dynamicQ?.busena || baseQuestions.busena[num] || baseQuestions.busena[1],
    seselis: dynamicQ?.seselis || baseQuestions.seselis[num] || baseQuestions.seselis[1],
    kryptis: dynamicQ?.kryptis || baseQuestions.kryptis[num] || baseQuestions.kryptis[1],
    stebejimas: dynamicQ?.stebejimas || baseQuestions.stebejimas[num] || baseQuestions.stebejimas[1]
  };
};

// Papildomi gilūs VIP sakiniai
const getDeepInsights = (lifePath) => {
  const insights = {
    1: 'Tavo vidinis lyderis šią savaitę ieško ne valdžios, o autentiškumo. Tikroji drąsa - ne daryti daugiau, o leisti sau būti savimi be pasiteisinimų. Atmink: tavo šviesa įkvepia kitus ne tada, kai ją demonstruoji, o tada, kai tiesiog ja esi.',
    2: 'Tavo jautrumas šią savaitę yra ne silpnybė, o supergebėjimas. Tu matai tai, ko kiti nemato - santykių niuansus, neišsakytus jausmus, subtilias energijas. Tavo dovana - ne spręsti problemas, o suprasti be žodžių.',
    3: 'Tavo kūrybiškumas šią savaitę nori tekėti laisvai, be perfekcionizmo kritiko. Atmink: kūryba yra procesas, ne produktas. Leisk sau žaisti, klysti, bandyti - būtent chaose gimsta naujos idėjos.',
    4: 'Tavo gebėjimas kurti struktūrą šią savaitę yra dovana, bet ne kalėjimas. Disciplina veikia geriausiai, kai ji tarnauja tavo vertybėms, o ne baimei. Paklausk savęs: ar kuriu saugumą - ar sienų?',
    5: 'Tavo laisvės troškimas šią savaitę kyla iš gilaus poreikio augti. Bet tikra laisvė - ne bėgimas nuo ribų, o sąmoningas jų pasirinkimas. Nuotykis gali būti ir viduje - tyrinėk savo gelmes.',
    6: 'Tavo meilė kitiems šią savaitę yra tavo didžiausia jėga, bet tik tada, kai nepamiršti mylėti savęs. Rūpinimasis savimi nėra egoizmas - tai būtina sąlyga, kad galėtum rūpintis kitais ilgai.',
    7: 'Tavo išmintis šią savaitę kyla iš tylos, ne iš knygų. Leisk sau nežinoti - būtent nežinojimo erdvėje gimsta tikros įžvalgos. Tavo protas yra įrankis, ne šeimininkas.',
    8: 'Tavo galia šią savaitę slypi ne kontrolėje, o pasitikėjime. Tikri lyderiai ne valdo - jie įgalina. Paklausk savęs: ar naudoju savo jėgą kurti - ar tik gintis?',
    9: 'Tavo gebėjimas paleisti šią savaitę yra dovana, ne praradimas. Kiekvienas užbaigimas atveria erdvę naujai pradžiai. Atleisk ne dėl kitų - atleisk, kad būtum laisvas.'
  };
  
  const baseNumber = lifePath === 11 ? 2 : lifePath === 22 ? 4 : lifePath === 33 ? 6 : lifePath;
  const num = baseNumber > 9 ? 1 : baseNumber;
  
  return insights[num] || insights[1];
};

export default function WeeklyCycleCard({ lifePath, weekNumber, isVIP = false }) {
  // Naudojame weekNumber (savaitės skaičių) ciklo duomenims, jei perduotas
  // Jei weekNumber nėra, grįžtame prie lifePath (atgalinis suderinamumas)
  const cycleNumber = weekNumber || lifePath;
  const cycleData = getWeeklyCycle(cycleNumber);
  // Perduodame savaitės energijos tipą (title) dinaminių klausimų generavimui
  const personalQuestions = getPersonalQuestions(lifePath, cycleData?.title);
  const deepInsight = getDeepInsights(cycleNumber);
  
  if (!cycleData) return null;

  const blocks = [
    {
      title: 'Būsena',
      emoji: '🌑',
      icon: Moon,
      content: cycleData.busena,
      question: personalQuestions.busena,
      color: 'purple'
    },
    {
      title: 'Šešėlis',
      emoji: '🌒',
      icon: Eye,
      content: cycleData.seselis,
      question: personalQuestions.seselis,
      color: 'indigo'
    },
    {
      title: 'Kryptis',
      emoji: '🌓',
      icon: Compass,
      content: cycleData.kryptis,
      question: personalQuestions.kryptis,
      color: 'blue'
    },
    {
      title: 'Stebėjimo taškas',
      emoji: '🌔',
      icon: Target,
      content: cycleData.stebejimas,
      question: personalQuestions.stebejimas,
      color: 'amber'
    }
  ];

  const colorClasses = {
    purple: 'from-purple-500/20 to-purple-600/10 border-purple-500/30',
    indigo: 'from-indigo-500/20 to-indigo-600/10 border-indigo-500/30',
    blue: 'from-blue-500/20 to-blue-600/10 border-blue-500/30',
    amber: 'from-amber-500/20 to-amber-600/10 border-amber-500/30'
  };

  const iconColorClasses = {
    purple: 'text-purple-400',
    indigo: 'text-indigo-400',
    blue: 'text-blue-400',
    amber: 'text-amber-400'
  };

  return (
    <Card className="bg-gradient-to-br from-violet-950/50 to-indigo-950/50 border-amber-500/20 p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="text-center flex-1">
          <h3 className="font-display text-xl text-amber-400 mb-2">
            Savaitinis „Vidinės Ašies" ciklas
          </h3>
          <p className="text-sm text-foreground/70">
            Tavo energija: <span className="text-purple-400 font-semibold">{cycleData.title}</span> {cycleData.emoji}
          </p>
        </div>
        {isVIP && (
          <Button
            size="sm"
            variant="ghost"
            onClick={() => copyToClipboard(
              `Savaitinis „Vidinės Ašies" ciklas\nEnergija: ${cycleData.title} ${cycleData.emoji}\n\n${deepInsight}\n\n🌑 Būsena:\n${cycleData.busena}\n💭 ${personalQuestions.busena}\n\n🌒 Šešėlis:\n${cycleData.seselis}\n💭 ${personalQuestions.seselis}\n\n🌓 Kryptis:\n${cycleData.kryptis}\n💭 ${personalQuestions.kryptis}\n\n🌔 Stebėjimo taškas:\n${cycleData.stebejimas}\n💭 ${personalQuestions.stebejimas}`,
              'Vidinės Ašies ciklas'
            )}
            className="text-amber-400 hover:text-amber-300 hover:bg-amber-500/10"
          >
            <Copy className="w-4 h-4" />
          </Button>
        )}
      </div>

      {/* Paaiškinimas apie 4 blokus */}
      <div className="bg-secondary/20 border border-amber-500/20 rounded-lg p-4 mb-6">
        <p className="text-sm text-foreground/80 leading-relaxed text-center italic">
          Tavo vidinis pasaulis nėra statiškas – jis juda ciklais. <strong>Būsena</strong> parodo tavo esamą energiją, <strong>Šešėlis</strong> – kur tavo jėga gali virsti stabdžiu, <strong>Kryptis</strong> – kur šiandien verta fokusuotis, o <strong>Stebėjimo taškas</strong> – tai tavo sąmoningumo inkaras, padedantis nepasiklysti kasdienybėje.
        </p>
      </div>

      {/* VIP papildomas gilusis turinys */}
      {isVIP && (
        <div className="bg-gradient-to-r from-amber-500/10 to-purple-500/10 border border-amber-500/30 rounded-lg p-4 mb-6">
          <p className="text-sm text-foreground/90 leading-relaxed italic">
            ✨ {deepInsight}
          </p>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {blocks.map((block, index) => {
          const Icon = block.icon;
          const isLocked = !isVIP && index > 0;
          
          return (
            <div
              key={block.title}
              className={`relative bg-gradient-to-br ${colorClasses[block.color]} border rounded-lg p-4 ${isLocked ? 'opacity-50' : ''}`}
            >
              {isLocked && (
                <div className="absolute inset-0 backdrop-blur-sm rounded-lg flex items-center justify-center z-10">
                  <span className="text-xs text-amber-400 bg-black/50 px-2 py-1 rounded">
                    🔒 VIP turinys
                  </span>
                </div>
              )}
              
              <div className="flex items-center gap-2 mb-3">
                <Icon className={`w-5 h-5 ${iconColorClasses[block.color]}`} />
                <h4 className="font-semibold text-foreground">
                  {block.emoji} {block.title}
                </h4>
              </div>
              
              <p className="text-sm text-foreground/80 leading-relaxed">
                {isLocked ? block.content.substring(0, 50) + '...' : block.content}
              </p>
              
              {/* Asmeninis klausimas - tik VIP */}
              {isVIP && !isLocked && (
                <div className="mt-3 pt-3 border-t border-white/10">
                  <p className="text-xs text-amber-400/90 italic">
                    💭 {block.question}
                  </p>
                </div>
              )}
            </div>
          );
        })}
      </div>
      
      {!isVIP && (
        <p className="text-center text-xs text-muted-foreground mt-4">
          Atverk pilną vaizdą ir atrakink visą savaitinį ciklą
        </p>
      )}
    </Card>
  );
}
